import ApiClient from './apiclient';
import GeoUtils from './geoutils';

/**
 * The points where we've loaded playgrounds
 */
let loaded = [];

/**
 * The radius of playgrounds loaded
 */
let distance = 2000;

let PlaygroundDataProvider = {

    isNewDataNeeded: function (location) {
        if (loaded.length == 0) {
            return true;
        }

        return loaded.every(item => GeoUtils.getDistance(item, location) > distance / 2);
    },

    loadPlaygrounds: function (location) {
        if (!this.isNewDataNeeded(location)) {
            return Promise.resolve(false);
        }

        console.log(`Loading playgrounds near ${location.lat}, ${location.lon}`);
        return ApiClient.loadPlaygroundsNear(location.lat, location.lon, distance).then(playgrounds => {
            loaded = [location]; // loaded.push(location);
            return playgrounds;
        });
    },

    getOperators: async function() {
        if (operators) {
            return operators;
        }

        operators = await ApiClient.loadOperators();
        return operators;
    }
}

export default PlaygroundDataProvider;